import { getCheckoutUrlDataShape } from '_services/Api/Membership/MembershipApi';
import LocalforageIphoneFix from '_services/LocalStorage/LocalforageIphoneFix';

const checkoutSelectedPlan = 'checkout_selected_plan';

/**
 * Setter and getter for Selected plan in IndexedDB through localforage
 */
const OpenCheckoutPlan = {
    /**
     * Set subscription through localforage
     * @param subscriptionConfig getCheckoutUrlDataShape
     */
    set: (subscriptionConfig: getCheckoutUrlDataShape): void => {
        LocalforageIphoneFix.setItem(
            checkoutSelectedPlan,
            JSON.stringify(subscriptionConfig),
        );
    },
    /**
     * Get subscriptionConfig from localforage. Returns a promise which contains the object, if set
     * @returns Promise<getCheckoutUrlDataShape | null>
     */
    get: (): Promise<string | null> => {
        return LocalforageIphoneFix.getItem(
            checkoutSelectedPlan,
        ) as Promise<string>;
    },
    /**
     * Remove the plan when done from IndexedDB
     * @returns Promise<void>
     */
    remove: (): Promise<void> => {
        return LocalforageIphoneFix.removeItem(checkoutSelectedPlan);
    },
};

export default OpenCheckoutPlan;
